/**
 * Properties of a discovered key
 */
export interface KeyContextResponse {

  /**
   * Id of the key
   */
  readonly keyId: string;

}